import { render } from "./RobertsProtocolModal.vue?vue&type=template&id=0bac2814&scoped=true"
import script from "./RobertsProtocolModal.vue?vue&type=script&lang=js"
export * from "./RobertsProtocolModal.vue?vue&type=script&lang=js"

import "./RobertsProtocolModal.vue?vue&type=style&index=0&id=0bac2814&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bac2814"]])

export default __exports__